import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import DesignerSessionHeader from './DesignerSessionHeader';
import BlockList from '../Block/BlockList';
import Palette from '../Palette';

import * as Utils from '../../../../lib/designerUtils';
import * as DesignerState from '../../../../state/reducer/designer/designer';
import * as CalendarState from '../../../../state/reducer/calendar/calendar';
import * as ClipboardState from '../../../../state/reducer/clipboard/clipboard';
import * as ToastState from '../../../../state/reducer/clipboard/toast';
import SegmentService, {
    EVENTS as SEGMENT_EVENTS
} from '../../../../lib/segment/SegmentService';
import Console from '../../../../lib/debug';

class Session extends PureComponent {
    copyAndReplace() {
        let session = this.props.session;
        let day = this.props.day;
        DesignerState.copyAndReplace(day, session);
    }

    deleteSession() {
        let session = this.props.session.data;
        ClipboardState.select([session.id]);
        ClipboardState.showDeleteDialog();

        SegmentService.track(SEGMENT_EVENTS['ClickCTA'].key, {
            sources: 'Web app',
            ctaLocation: 'Session builder',
            ctaText: 'Delete Session icon'
        });
    }

    exportSession() {
        let session = this.props.session.data;
        DesignerState.toggleSaveSessionToLibrary(true, session);

        SegmentService.track(SEGMENT_EVENTS['ClickCTA'].key, {
            sources: 'Web app',
            ctaLocation: 'Session builder',
            ctaText: 'Save Session to Library icon'
        });
    }

    sessionClick() {
        let session = this.props.session;
        if (session.data.published === 1) {
            ToastState.showWarningMessage(
                'Sorry! Cannot edit a published session.'
            );
        }
    }

    togglePublish(event) {
        let dispatch = this.props.dispatch;
        let session = this.props.session;
        let published = session.data.published === 1 ? 0 : 1;
        DesignerState.togglePublished(dispatch, session, published);
        event.preventDefault();
        event.stopPropagation();

        SegmentService.track(SEGMENT_EVENTS['ClickCTA'].key, {
            sources: 'Web app',
            ctaLocation: 'Session builder',
            ctaText: published ? 'Unpublish Session' : 'Publish Session'
        });
    }

    updateInstructions(event) {
        let dispatch = this.props.dispatch;
        let session = this.props.session;
        let value = event.target.value;
        if (value !== session.data.instruction) {
            DesignerState.updateSession(
                dispatch,
                session.data,
                'instruction',
                value
            );
        }
    }

    updateSession(title) {
        let session = this.props.session;
        let dispatch = this.props.dispatch;
        if (title !== session.data.title) {
            DesignerState.updateSession(dispatch, session.data, 'title', title);
        }

        SegmentService.track(SEGMENT_EVENTS['ClickCTA'].key, {
            sources: 'Web app',
            ctaLocation: 'Session builder',
            ctaText: 'Edit Title icon'
        });
    }

    render() {
        Console.render('DesignerSession');
        if (!this.props.session) return null;

        let {
            blockLinkingKey,
            dispatch,
            day,
            session,
            isPubEnabled,
            isProgram,
            publishDate
        } = this.props;
        let isPublished = parseInt(session.data.published, 10) === 1;
        let isSubscription = Utils.isSubscription(
            session.data,
            CalendarState.getProgramType()
        );

        let className = 'session';
        let palette = null;
        if (isSubscription) {
            className += ' published';
        } else {
            if (isPublished) {
                className += ' published';
            } else if (!isPublished && !isPubEnabled) {
                palette = (
                    <Palette
                        day={day}
                        session={session.data}
                        dispatch={dispatch}
                    />
                );
                className += ' unpublished';
            } else if (!isPublished && isPubEnabled) {
                palette = (
                    <Palette
                        day={day}
                        session={session.data}
                        dispatch={dispatch}
                    />
                );
                className += ' scheduled';
                publishDate = Utils.calculatePublishDate(
                    session.data,
                    this.props.pubDays,
                    this.props.pubTime
                );
            }
        }

        return (
            <div className={className}>
                <DesignerSessionHeader
                    date={day.date}
                    sessionId={session.data.id}
                    logo={session.data.logo}
                    title={session.data.title}
                    instruction={session.data.instruction}
                    isPublished={isPublished}
                    isPubEnabled={isPubEnabled}
                    isSubscription={isSubscription}
                    isProgram={isProgram}
                    publishDate={publishDate}
                    onTitleBlur={this.updateSession.bind(this)}
                    onTogglePublish={this.togglePublish.bind(this)}
                    onCopyAndReplace={this.copyAndReplace.bind(this)}
                    onExport={this.exportSession.bind(this)}
                    onDelete={this.deleteSession.bind(this)}
                    onUpdateInstruction={this.updateInstructions.bind(this)}
                    triggerToast={this.sessionClick.bind(this)}
                    athleteId={this.props.athleteId}
                    designerInfo={this.props.designerInfo}
                />
                <div onClick={this.sessionClick.bind(this)}>
                    <BlockList
                        dispatch={dispatch}
                        blockKeys={session.data.setKeys}
                        session={session.data}
                        blockLinkingKey={blockLinkingKey}
                    />
                    {palette}
                </div>
            </div>
        );
    }
}

const mapSessionStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        session: state.calendar.sessionTree[ownProps.sessionId],
        isPubEnabled: state.calendar.infoTree.team.pub_enabled === 1,
        pubDays: state.calendar.infoTree.team.pub_days,
        pubTime: state.calendar.infoTree.team.pub_time,
        athleteId: state.calendar.infoTree.team.athlete_id,
        blockLinkingKey: state.calendar.uiTree.blockLinkingKey,
        designerInfo: state.calendar.infoTree.designerInfo
    };
};

Session = connect(mapSessionStateToProps)(Session);

export default Session;
